<template>
  <button class="sc-user-input--button-icon-wrapper">
    <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <title id="send-icon">{{ $t('Send') }}</title>
      <path d="M4.02 42l41.98-18-41.98-18-.02 14 30 4-30 4z" />
      <path d="M0 0h48v48h-48z" fill="none" />
    </svg>
    <!--
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 18"
      x="0px"
      y="0px"
      :aria-labelledby="$t('Send')"
      role="presentation"
    >
      <title id="send-icon" lang="en">{{ $t('Send') }}</title>
      <g>
        <path
          d="M17.218,2.268L2.477,8.388C2.13,8.535,2.164,9.05,2.542,9.134L9.33,10.67l1.535,6.787c0.083,0.377,0.602,0.415,0.745,0.065l6.123-14.74C17.866,2.46,17.539,2.134,17.218,2.268 M3.92,8.641l11.772-4.89L9.535,9.909L3.92,8.641z M11.358,16.078l-1.268-5.613l6.157-6.157L11.358,16.078z"
        />
      </g>
    </svg>-->
  </button>
</template>

<script>
export default {};
</script>

<style scoped>
.sc-user-input--button-icon-wrapper {
  background: none;
  border: none;
  padding: 0px;
  margin: 0px;
  outline: none;
  cursor: pointer;
}
.sc-user-input--button-icon-wrapper:focus {
  outline: none;
}
.sc-user-input--button-icon-wrapper svg {
  width: 16px;
  height: 16px;
  cursor: pointer;
  align-self: center;
  outline: none;
  display: inline-block;
  vertical-align: middle;
}
.sc-user-input--button-icon-wrapper svg:hover path {
  filter: contrast(15%);
}
</style>